export default "__VITE_ASSET__f3867865__"